import {removeLocalStorageItem} from '../../../../util/localStorage';

export const clearChatPreviewSessionKey = (instanceId: string | number) => {
    // Matches the sessionKey we create in peanut/src/chat.tsx
    const sessionKey = `${instanceId}_sessionId`;
    removeLocalStorageItem(sessionKey);
};
